module.exports = __webpack_public_path__ + "img/arrow-down.ba287ecc.svg";